/**
 * @desc 获取表格表头定义 5
 */

export const allColumns={
    /**
     * @desc 库存不足预警
     */
    'LISTING_WARN_001': [
        {id: "picture", header: "图片", field: "picture:image", width: "60px",},
        {id: "msku", header: "MSKU", field: "msku", width: 'auto', copyable: true, overflowLine: 1},
        {id: "fnsku", header: "FNSKU", field: "fnsku", width: 'auto', overflowLine: 1},
        // {id: "marketName", header: "店铺/站点", field: "slot:marketName", minWidth: "150px"},
        {id: "useQuantity", header: "可用量", field: "useQuantity", width: 'auto'},
        {id: "fulfillableQuantity", header: "可售量", field: "fulfillableQuantity", width: 'auto'},
        {id: "waitShipmentQuantity", header: "待出运", field: "waitShipmentQuantity", width: 'auto'},
        {id: "workingQuantity", header: "计划入库量", field: "workingQuantity", width: 'auto'},
        {id: "onWayQuantity", header: "在途量", field: "onWayQuantity", width:'auto'},
        {id: "reservedQuantity", header: "预留", field: "reservedQuantity", width:'auto'},
        {id: " fulfillableDay", header: "FBA库存可售天数", field: "slot:fulfillableDay", minWidth:'150px', width: 'auto'},
    ],

    /**
     * @desc FBA库存滞销
     */
    'LISTING_WARN_002':[
        {id: "picture", header: "图片", field: "picture:image", width: "60px",},
        {id: "asin", header: "ASIN", field: "slot:asin", minWidth: "150px"},
        {id: "msku", header: "MSKU", field: "msku", minWidth: "150px", copyable: true, overflowLine: 1},
        {id: "slowsalesRate", header: "FBA滞销率", field: "slot:slowsalesRate", minWidth: "150px"},
        {id: "fbaStock", header: "FBA在库量", field: "fbaStock", minWidth: "150px"},
        {id: "slowSales", header: "FBA滞销量", field: "slowSales", minWidth: "150px"}
    ],

    /**
     * @desc Listing下架/停售
     */
    'LISTING_WARN_003':[
        {id: "picture", header: "图片", field: "picture:image", width: "60px",},
        {id: "asin", header: "ASIN", field: "slot:asin", minWidth: "150px"},
        {id: "msku", header: "MSKU", field: "msku", minWidth: "150px", copyable: true},
        {id: "warnContent", header: "预警内容", field: "warnContent", minWidth: "250px"}
    ],

    /**
     * @desc 星级评分异常预警
     */
    'LISTING_WARN_004':[
        {id: "picture", header: "图片", field: "picture:image", width: "60px",},
        {id: "asin", header: "ASIN", field: "slot:asin", minWidth: "150px"},
        {id: "msku", header: "MSKU", field: "msku", minWidth: "150px", copyable: true},
        {id: "yesterdayTotalStar", header: "昨日星级评分", field: "yesterdayStar",minWidth: "150px"},
        {id: "todayTotalStar", header: "今日星级评分", field: "todayStar",minWidth: "150px"},
    ],

    /**
     * @desc 评星数异常预警
     */
    'LISTING_WARN_005':[
        {id: "picture", header: "图片", field: "picture:image", width: "60px",},
        {id: "asin", header: "ASIN", field: "slot:asin", minWidth: "150px"},
        {id: "msku", header: "MSKU", field: "msku", minWidth: "150px", copyable: true},
        {id: "yesterdayTotalStar", header: "昨日总评星数", field: "yesterdayTotalStar",minWidth: "150px"},
        {id: "todayTotalStar", header: "今日总评星数", field: "todayTotalStar",minWidth: "150px"},
    ],

    /**
     * @desc 品牌审核管理
     */
    'ADS_SB_REVIEW_001':[
        {id: "marketName", header: "店铺/站点", field: "slot:marketName", width: "200px"},
        {id: "warnContent", header: "预警内容", field: "warnContent", width:'auto'}]
}











